import axios from "axios";

let baseUrl = window.location.origin;
if (window.location.hostname === 'localhost') {
   baseUrl = "http://localhost:2021/";
  // baseUrl = "https://sky-admin-test-dev-dot-production-377311.uk.r.appspot.com";
}

export const BASE_URL_AUTH = window.location.origin;
export const BASE_URL = baseUrl;

const axiosInt = axios.create({
  baseURL: BASE_URL + "/",
});

axiosInt.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error || error.response || error.response.data),
);

export default axiosInt;
